import { apolloClient } from "@/plugins/vue-apollo.js";

const createContactUs = (_variables, searchKey) => {
  // , limit, skip
  let responseFromApi;
  let variables = _variables;
  let search = searchKey
  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/settings/api/mutations/contactUs/create_contact_us.graphql"),
      variables: variables,
      update: (store, { data }) => {
        const query = {
          query: require("@/settings/api/queries/contactUs/contact_us_query.graphql"),
          variables: {
            searchKey: search
          }
        };
        let allContactUs = store.readQuery(query);
        allContactUs.contactUs.contacts.unshift(data.createContactUs); //push to top
        store.writeQuery({
          ...query,
            data: allContactUs,
        });
      }
    })
    .catch(error => {
      return error;
    });
  return responseFromApi;
};
export { createContactUs };
